import Vue from "vue";

import "normalize.css/normalize.css"; // A modern alternative to CSS resets

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/zh-CN"; // lang i18n
import VCharts from "v-charts";

import "@/styles/index.scss"; // global css
import utils from "@/utils/util.js";
import dateUtils from "@/utils/date.js";
import App from "./App";
import router from "./router";
import store from "./store";
import { getCookie } from "@/utils/support";
import request from "@/utils/request.js";
import dateJs from "@/utils/date.js";
import "@/icons"; // icon
import "@/permission"; // permission control
import "@/styles/my.css";

Vue.use(ElementUI, { locale });
Vue.use(VCharts);
import VueQuillEditor from "vue-quill-editor";
//一定要引入这三个css，不然文本编辑器会出现不规则黑白几何图形
//这三个css可以在main.js中引入，也可以在具体使用的.vue文件中引入
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

Vue.use(VueQuillEditor);

Vue.prototype.utils = utils;
Vue.prototype.$dateUtils = dateJs;

// const { hostname, protocol } = window.location;
// request.defaults.baseURL = protocol + "//" + hostname + ":8083/";
request.defaults.baseURL = process.env.BASE_API;
Vue.prototype.$http = request;

Vue.config.productionTip = false;
Vue.prototype.$EventBus = new Vue();

router.beforeEach((to, from, next) => {
  if (to.matched.some(res => res.meta.requireAuth)) {
    // 验证是否需要登陆
    let token = getCookie("token");

    if (token === null || token === undefined || token === "") {
      // 查询本地存储信息是否已经登陆
      next({
        path: "/login" // 未登录则跳转至login页面
      });
    } else {
      next();
    }
  } else {
    next();
  }
});
new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js